//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import connect from 'react-redux/es/connect/connect';
import ListagemPage from '../../components/templates/ListagemPage';
import { tableHelper } from '../../helpers/tableHelper';
import withAbility from '../../hoc/withAbility';
import { pontoAtendimentoService } from '../../services/pontoAtendimento.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import PontoAtendimentoCrudListFilter from './PontoAtendimentoCrudListFilter';

const endPoint = '/pontoAtendimento/novo/';
const endPointView = '/pontoAtendimento/';
class PontoAtendimentoCrudList extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);

    const isSudo = props.user && props.user.perfis.includes('SUDO');

    this.columns = [
      {
        path: 'id',
        title: 'Identificador',
        isKey: true,
        dataSort: false,
        className: 'txtBold',
        hidden: true,
      },
      {
        path: 'nome',
        title: 'Nome',
        isKey: false,
        dataSort: false,
        className: 'txtBold',
      },
      ...(isSudo
        ? [
            {
              path: 'clienteNome',
              title: 'Cliente',
              isKey: false,
              dataSort: false,
            },
          ]
        : []),

      {
        path: 'regional',
        title: 'Regional',
        isKey: false,
        dataSort: false,
      },
    ];

    const fields = this.columns.map((col) => col.path);
    const labels = this.columns.map((col) => col.title);

    this.state = {
      labels,
      fields,
    };
  }

  handleRowClick = (row: e) => {
    if (this.props.ability.can('update', 'PontoAtendimento')) {
      this.props.history.push(endPointView + row.id);
    }
  };

  handleNewButton = (row: e) => {
    this.props.history.push(endPoint);
  };
  render() {
    const fields = this.state.fields;

    const tableColumn = _.map(this.columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={tableHelper.renderCustom}
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    let filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user.extension,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Pontos de Atendimento"
          subTitle=" "
          canBack={false}
        />
        <ListagemPage
          newButtonActionClick={() => {
            this.props.history.push('/pontoAtendimento/novo');
          }}
          delete={() => {}}
          service={pontoAtendimentoService}
          showNewButton={this.props.ability.can('create', 'PontoAtendimento')}
          labelNewButton="Novo Ponto de Atendimento"
          defaultOrder={'nome'}
          defaultDirection={'asc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={PontoAtendimentoCrudListFilter}
          fields={fields}
          array={'pontoAtendimentos'}
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(withAbility(PontoAtendimentoCrudList));
